import { render, staticRenderFns } from "./GithubBrowser.vue?vue&type=template&id=268c2c73&"
import script from "./GithubBrowser.vue?vue&type=script&lang=js&"
export * from "./GithubBrowser.vue?vue&type=script&lang=js&"
import style0 from "./GithubBrowser.vue?vue&type=style&index=0&id=268c2c73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports